export default function Section({ children, className, isContainer = false }) {
  return (
    <div
      className={`${
        isContainer ? "max-w-[1440px] mx-auto px-3 md:px-6 lg:px-11" : ""
      }  lg:my-[70px] my-[32px] xl:my-[3vw] ${className} `}
    >
      {children}
    </div>
  );
}
